import { Button, Form, Modal } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { useState } from 'react';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';
import FormComponent from './FormComponent';

const AddComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { PUBLICSETTINGS } = useStore();
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);

	const handleSubmit = (data) => {
		setSaving(true);
		PUBLICSETTINGS.addPublicSettings(data)
			.then(() => {
				Notification.success({
					message: Message().CRUD.ADD('Public Settings'),
				});
				closeModal();
			})
			.catch((e) => {})
			.finally(() => setSaving(false));
	};

	const handelChange = () => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch(() => {
				setDisabled(true);
			});
	};

	const closeModal = () => {
		form.resetFields();
		onClose();
	};

	return (
		<Modal
			title="Add Public Settings"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="AddForm"
					>
						Add Settings
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<FormComponent
				id="AddForm"
				form={form}
				onFinish={handleSubmit}
				handleChange={handelChange}
			/>
		</Modal>
	);
});
export default AddComponent;
